<template>
    <img src="/logoicon.png" alt="">
</template>
